<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/auth";
import CreateCredentials from "@/components/account/CreateCredentials";

/**
 * Reset Password component
 */
export default {
  page: {
    title: "Crear Contraseña",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    CreateCredentials,
    Layout
  }
};
</script>

<template>
  <Layout>
    <create-credentials submit-button-text="Crear Contraseña" action="create"></create-credentials>
  </Layout>
</template>
